module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_019.png
// module id = 2366
// module chunks = 5